/* eslint-disable valid-jsdoc */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */

var isGpcEnabled = require('../utilities').isGpcEnabled;

/**
 * Determine if a Global Privacy Control signal is active (server-detected Sec-GPC header or browser GPC flag) on a site where GPC detection is enabled. Uses .attr() for live DOM reads vs cached .data().
 * @returns {boolean} true if GPC is active
 */
function isGpcActive() {
    var $trackingConsent = $('.tracking-consent');
    var gpcFeatureEnabled = $trackingConsent.attr('data-gpc-detection-enabled') === 'true';
    var gpcDetectedServerSide = $trackingConsent.attr('data-gpc') === 'true';
    return gpcFeatureEnabled && (isGpcEnabled() || gpcDetectedServerSide);
}

/**
 * Force the Targeting Cookies toggle to Off and read-only, and reveal the GPC notification,
 * whenever a Global Privacy Control opt-out signal is detected. The notification is already shown
 * server-side when applicable; this only needs to additionally reveal it for the navigator-only
 * edge case described in isGpcActive().
 */
function applyGpcRestrictions() {
    if (!isGpcActive()) {
        return;
    }
    $('.consentPref-targeting').prop('checked', false).prop('disabled', true);
    $('.gpc-notification').removeClass('d-none');
    $('#targeting-disabled-reason').removeClass('d-none');
    $('#targeting-disabled-reason').closest('.col-8').removeClass('pt-2').addClass('pt-0');
}

/**
 * Moves the specified modal to <body> when the email signup tray is present
 * to prevent z-index/stacking issues.
 *
 * @param {string} modalId jQuery selector for the modal (e.g. "#cookieModal")
 */
function appendModalToBodyIfTrayExists(modalId) {
    var $modal = $(modalId);
    var $tray = $('.tray-modal.email-signup-tray');
    if ($tray.length && $modal.length) {
        $modal.appendTo('body');
    }
}

/**
 * Handle clicking on "Accept All Cookies" consent button
 */
function handleConsentAcceptBtn() {
    $(document).off('click', '.consent-accept-btn').on('click', '.consent-accept-btn', function (e) {
        e.preventDefault();

        var trackingConsentData = $('.tracking-consent');
        var token = trackingConsentData.data('token');
        var tokenName = trackingConsentData.data('tokenname');
        var data = {};
        data[tokenName] = token;
        data.gpc = isGpcActive();

        var url = $(this).data('url');

        $.ajax({
            url: url,
            data: data,
            dataType: 'json',
            type: 'POST',
            success: function (response) {
                // Hide the cookie banner
                $('#cookieModal').modal('hide');
                
                // Mark as consented to prevent showing again
                trackingConsentData.addClass('consented');
                $('#consentTrackingModal').modal('hide');
                
                $(document).trigger('consent:accepted', [response.consentData]);
            
            },
            error: function (err) {
            }
        });
    });
}

/**
 * Apply default consent preferences based on site preference. Accepts optional callback to execute after defaults are written (or if URL is not configured).
 * @param {Function} onComplete - Callback to invoke after defaults are fetched and applied (required for proper ordering with GPC restrictions)
 */
function applyDefaultConsentPreferences(onComplete) {
    var trackingConsentData = $('.tracking-consent');
    var defaultPrefsUrl = trackingConsentData.data('defaultprefsurl');
    
    if (!defaultPrefsUrl) {
        // No URL configured; invoke callback immediately
        if (onComplete) onComplete();
        return;
    }
    
    $.ajax({
        url: defaultPrefsUrl,
        type: 'GET',
        dataType: 'json',
        success: function (response) {
            if (response.success && response.defaultPreferences) {
                var defaults = response.defaultPreferences;
                
                // Set default checked state for each checkbox
                $('.consentPref-performance').prop('checked', defaults.performance);
                $('.consentPref-functional').prop('checked', defaults.functional);
                $('.consentPref-targeting').prop('checked', defaults.targeting);
            }
            // Invoke callback after defaults are written
            if (onComplete) onComplete();
        },
        error: function (err) {
            // Invoke callback even on error to avoid blocking subsequent operations
            if (onComplete) onComplete();
        }
    });
}

/**
 * Handle clicking on "Reject All" consent button - uncheck all preferences and trigger save
 */
function handleRejectAllPreferences() {
    $(document).off('click', '.consent-reject-btn').on('click', '.consent-reject-btn', function (e) {
        e.preventDefault();
        $('.consentPref-performance').prop('checked', false);
        $('.consentPref-functional').prop('checked', false);
        $('.consentPref-targeting').prop('checked', false);
        $('.save-consent-preferences').trigger('click');
    });
}

/**
 * Handle saving preferences from "Show All Cookies" modal
 */
function handleConsentPreferences() {
    $(document).off('click', '.save-consent-preferences').on('click', '.save-consent-preferences', function (e) {
        e.preventDefault();

        var trackingConsentData = $('.tracking-consent');
        var token = trackingConsentData.data('token');
        var tokenName = trackingConsentData.data('tokenname');
        var url = $(this).data('url');

        var preferences = {
            performance: $('.consentPref-performance').is(':checked'),
            functional: $('.consentPref-functional').is(':checked'),
            targeting: isGpcActive() ? false : $('.consentPref-targeting').is(':checked')
        };

        var data = {};
        data[tokenName] = token;
        data.preferences = JSON.stringify(preferences);
        data.gpc = isGpcActive();

        $.ajax({
            url: url,
            type: 'POST',
            data: data,
            dataType: 'json',
            success: function (res) {
                if (res.success) {
                    // Mark if preferences saved successfully
                    preferencesSaved = true;
                    
                    // Hide the cookie banner
                    $('#cookieModal').modal('hide');
                    
                    // Mark as consented to prevent showing again
                    $('.tracking-consent').addClass('consented');
                    
                    $('#consentTrackingModal').modal('hide');
                    $(document).trigger('consent:preferencesSaved', [res.consentData]);
                    
                }
            },
            error: function (err) {
            }
        });
    });
}

// flag to track if OK button was clicked
var preferencesSaved = false;
var savedCheckboxStates = {};

/**
 * Check if a cookie exists
 * @param {string} name - The name of the cookie to check
 * @returns {boolean} - True if the cookie exists, false otherwise
 */
function hasCookie(name) {
    return document.cookie.indexOf(name + '=') !== -1;
}

/**
 * Get user preferences from consentPreferences (persists across page refresh)
 */
function getUserSessionPreferences() {
    if (!hasCookie('consentPreferences')) return null;
    try {
        var match = document.cookie.match(/consentPreferences=([^;]+)/);
        if (!match) return null;
        
        var cookieValue = decodeURIComponent(match[1]);
        var data = JSON.parse(cookieValue);
        
        if (typeof data === 'string') {
            data = JSON.parse(data);
        }
        
        if (!data || !data.consent || !data.consent.consentLevels) return null;
        
        // Convert to simple format
        var prefs = { performance: false, functional: false, targeting: false };
        data.consent.consentLevels.forEach(function(level) {
            if (level.category === 'Performance Cookies') prefs.performance = level.status === 'Agreed';
            if (level.category === 'Functional Cookies') prefs.functional = level.status === 'Agreed';
            if (level.category === 'Targeting Cookies') prefs.targeting = level.status === 'Agreed';
        });
        return prefs;
    } catch (e) {
        return null;
    }
}

/**
 * Load preferences - either from cookie or site defaults. Applies GPC restrictions after preferences are loaded to avoid race condition with async default-fetch.
 */
function loadPreferencesIntoModal() {
    // Check if user already saved preferences
    var sessionPrefs = getUserSessionPreferences();
    
    if (sessionPrefs !== null) {
        // Load from cookie (synchronous)
        $('.consentPref-performance').prop('checked', sessionPrefs.performance);
        $('.consentPref-functional').prop('checked', sessionPrefs.functional);
        $('.consentPref-targeting').prop('checked', sessionPrefs.targeting);
        // Apply GPC restrictions after preferences are set
        applyGpcRestrictions();
    } else {
        // Load site preference defaults (asynchronous); apply GPC restrictions after defaults complete
        applyDefaultConsentPreferences(function() {
            applyGpcRestrictions();
        });
    }
}

/**
 * Handle opening consentTrackingModal from preferences button
 * Prevents Bootstrap's automatic modal-open removal during transition
 */
function handleOpenConsentTrackingModal() {
    $(document).off('click', '.open-consent-tracking-modal').on('click', '.open-consent-tracking-modal', function (e) {
        e.preventDefault();
        preferencesSaved = false;
        
        // Load preferences (from cookie or defaults)
        loadPreferencesIntoModal();
        appendModalToBodyIfTrayExists('#consentTrackingModal');
        
        // Hide the first modal without calling .modal('hide') to preserve scroll lock
        // This hides the DOM visually but keeps modal-open class on body
        $('#cookieModal').hide().attr('aria-hidden', 'true');
        
        // Show the new modal while keeping the scroll lock active
        $('#consentTrackingModal').modal('show');
    });
}

/**
 * Handle modal show event
 */
function handleModalShow() {
    // Save checkbox states after modal is shown
    $('#consentTrackingModal').on('shown.bs.modal', function () {
        savedCheckboxStates = {
            performance: $('.consentPref-performance').is(':checked'),
            functional: $('.consentPref-functional').is(':checked'),
            targeting: $('.consentPref-targeting').is(':checked')
        };
    });
}

/**
 * Handle modal hide event
 */
function handleModalHide() {
    $('#cookieModal').on('hidden.bs.modal', function () {
        $('html').removeAttr('tryit-modal-open');
    });
    $('#consentTrackingModal').on('hidden.bs.modal', function () {
        // If user clicked X  restore original states
        if (!preferencesSaved && savedCheckboxStates.performance !== undefined) {
            $('.consentPref-performance').prop('checked', savedCheckboxStates.performance);
            $('.consentPref-functional').prop('checked', savedCheckboxStates.functional);
            $('.consentPref-targeting').prop('checked', savedCheckboxStates.targeting);
        }
        
        $('html').removeAttr('tryit-modal-open');

        // Hide cookieModal when consentTrackingModal is closed
        $('#cookieModal').modal('hide');
    });
}

/**
 * Handle clicking on "Do Not Sell/ Cookie Preferences" link to show cookie modal
 */
function handleCookiePreferencesLink() {
    $(document).off('click', '.cookie-preferences-link').on('click', '.cookie-preferences-link', function (e) {
        e.preventDefault();
        $('html').attr('tryit-modal-open', 'true');

        // Show the cookie consent modal
        appendModalToBodyIfTrayExists('#consentTrackingModal');
        $('#consentTrackingModal').modal('show');
    });
}

/**
 * Handle close footer button click - hide the consent footer
 */
function handleConsentClose() {
    $(document).off('click', '.footer-close-btn').on('click', '.footer-close-btn', function (e) {
        e.preventDefault();
        $('#cookieModal').modal('hide');
        $('#consentTrackingModal').modal('hide');
    });
}

/**
 * Initialize consent modal on page load - show if not consented, hide if consented. Also set up event handlers for buttons and links.
 */
function initConsentModal() {
    var trackingConsent = $('#trackingConsent').val() === 'true';
    if ($('.consented').length === 0 && $('.tracking-consent').hasClass('marykay-api-true') && !trackingConsent) {
        appendModalToBodyIfTrayExists('#cookieModal');
        applyGpcRestrictions();
        $('html').attr('tryit-modal-open', 'true');
        $('#cookieModal').modal('show');
    } else {
        $('html').removeAttr('tryit-modal-open');
        $('#cookieModal').modal('hide');
    }
    $('body').on('click', '.custom-switch.custom-switch__check', function (e) {
        e.stopPropagation();
    });
}

// Auto-initialize when DOM is ready
$(document).ready(function() {
    // Banner is already hidden by ISML if user consented
    // No need to check here since ISML handles it with: ${pdict.tracking_consent != null ? 'style="display: none;"' : ''}
    
    handleConsentAcceptBtn();
    handleConsentPreferences();
    handleOpenConsentTrackingModal();
    handleModalShow();
    handleModalHide();
    handleCookiePreferencesLink();
    handleConsentClose();
    initConsentModal();
    handleRejectAllPreferences();
});

// Export functions if using modules (optional)
module.exports = {
    handleConsentAcceptBtn: handleConsentAcceptBtn,
    handleConsentPreferences: handleConsentPreferences,
    applyDefaultConsentPreferences: applyDefaultConsentPreferences,
    handleOpenConsentTrackingModal: handleOpenConsentTrackingModal,
    handleModalShow: handleModalShow,
    handleModalHide: handleModalHide,
    handleCookiePreferencesLink: handleCookiePreferencesLink,
    handleConsentClose: handleConsentClose,
    isGpcActive: isGpcActive,
    applyGpcRestrictions: applyGpcRestrictions
};